<template>
	<div class="home-page" :class="{ 'is-h5': isH5Layout }">
		<div class="app-container" :class="{ fullscreen: !isFullscreen }">
			<div class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<div class="user-head-image" title="个人中心">
							<head-image :name="$store.state.userStore.userInfo.nickName" :size="38"
								:url="$store.state.userStore.userInfo.headImage" @click.native="showSetting">
							</head-image>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item" title="消息">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item" title="好友">
									<span class="icon iconfont icon-friend"></span>
									<div v-show="recvCount > 0" class="unread-text">{{ recvCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item" title="群组">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
									<div v-show="groupApplyCount > 0" class="unread-text">{{ groupApplyCount > 99 ?
										'99+' : groupApplyCount }}</div>
								</div>
							</router-link>
						</div>
					</div>

					<div class="botoom">
						<div class="botoom-item" @click="handleFresh" title="刷新,不流畅时可点击刷新">
							<i class="icon el-icon-refresh"></i>
						</div>
						<div class="botoom-item h5-hide" title="建议使用Chrome浏览器">
							<a href="https://www.google.com/intl/zh-CN/chrome" target="_blank">
								<span class="icon el-icon-help" style="font-size: 20px;"></span>
							</a>
						</div>
						<div class="botoom-item" @click="handleVoice" :title="isCloseVoice ? '打开提示声' : '关闭提示声'">
							<i :class="isCloseVoice ? 'el-icon-turn-off-microphone' : 'el-icon-microphone'"></i>
						</div>
						<div class="botoom-item h5-hide" @click="handleFullScreen" :title="isFullscreen ? '全屏' : '退出全屏'">
							<i class="el-icon-full-screen"></i>
						</div>
						<div class="botoom-item" @click="showSetting" title="设置">
							<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
						</div>
						<a class="botoom-item h5-hide" :href="$store.state.configStore.app.downloadUrl" target="_blank"
							title="下载APP">
							<span class="el-icon-download" style="font-size: 20px"></span>
						</a>
						<div class="botoom-item" @click="onExit()" title="退出系统">
							<span class="icon iconfont icon-exit"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view></router-view>
			</div>
			<setting ref="setting"></setting>
			<user-info v-show="uiStore.userInfo.show" :pos="uiStore.userInfo.pos" :user="uiStore.userInfo.user"
				@close="$store.commit('closeUserInfoBox')"></user-info>
			<full-image :visible="uiStore.fullImage.show" :url="uiStore.fullImage.url"
				@close="$store.commit('closeFullImageBox')"></full-image>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
		</div>
		<canvas id="myCanvas" />
	</div>
</template>

<script>
import { getUserKey } from '@/utils/common.js';
import { H5_MEDIA, isH5 } from '@/utils/h5.js';
import notificationManager from '@/utils/notification.js';
import LivekitPrivateApi from '@/api/livekitPrivateApi';
import { isCallEvent } from '@/api/livekitAction';
import FullImage from '../components/common/FullImage.vue';
import HeadImage from '../components/common/HeadImage.vue';
import UserInfo from '../components/common/UserInfo.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import Setting from '../components/setting/Setting.vue';

// 页面在后台超过该时长后，回到前台时先探测连接，僵死再静默重连
const LONG_BACKGROUND_MS = 2 * 60 * 1000;
// 防抖：避免 visibilitychange / focus 连续触发多次重连
const VISIBILITY_RESUME_DEBOUNCE_MS = 800;
// 心跳探测超时：超时则视为僵尸连接
const CONNECTION_PROBE_MS = 2500;
// 通话事件接口实例（无内部状态，置于模块级避免进入响应式系统）
const livekitPrivateApi = new LivekitPrivateApi();

export default {
	components: {
		HeadImage,
		Setting,
		UserInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo
	},
	data() {
		return {
			lastPlayAudioTime: new Date().getTime() - 1000,
			isFullscreen: false,
			isCloseVoice: false,
			reconnecting: false,
			wsKicked: false,
			wsReady: false,
			lastHiddenAt: null,
			visibilityResumeTimer: null,
			privateMessagesBuffer: [],
			groupMessagesBuffer: [],
			systemMessagesBuffer: [],
			processedJoinTipIds: {},
			// 一对一通话事件：拉取游标与去重表
			livekitEventMinId: 0,
			livekitEventPulling: false,
			processedLivekitEvents: {},
			isH5Layout: isH5()
		}
	},
	methods: {
		syncH5Layout() {
			this.isH5Layout = isH5();
		},
		bindH5Layout() {
			this.syncH5Layout();
			if (typeof window === 'undefined' || !window.matchMedia) {
				return;
			}
			this._h5Mql = window.matchMedia(H5_MEDIA);
			this._h5Handler = () => this.syncH5Layout();
			if (this._h5Mql.addEventListener) {
				this._h5Mql.addEventListener('change', this._h5Handler);
			} else if (this._h5Mql.addListener) {
				this._h5Mql.addListener(this._h5Handler);
			}
		},
		unbindH5Layout() {
			if (!this._h5Mql || !this._h5Handler) {
				return;
			}
			if (this._h5Mql.removeEventListener) {
				this._h5Mql.removeEventListener('change', this._h5Handler);
			} else if (this._h5Mql.removeListener) {
				this._h5Mql.removeListener(this._h5Handler);
			}
			this._h5Mql = null;
			this._h5Handler = null;
		},
		handleFresh() {
			location.reload();
		},
		handleFullScreen() {
			this.isFullscreen = !this.isFullscreen;
			localStorage.setItem(getUserKey('isFullscreen', this.mine.id), this.isFullscreen ? 'true' : 'false');
		},
		handleVoice() {
			this.isCloseVoice = !this.isCloseVoice;
			localStorage.setItem(getUserKey('isCloseVoice', this.mine.id), this.isCloseVoice ? 'true' : 'false');
		},
		async init() {
			// 初始化桌面通知
			await this.initNotification();
			// 等待用户信息加载完成后再赋值
			const waitMine = () => {
				if (this.mine && this.mine.id) {
					this.isFullscreen = localStorage.getItem(getUserKey('isFullscreen', this.mine.id)) === 'true';
					this.isCloseVoice = localStorage.getItem(getUserKey('isCloseVoice', this.mine.id)) === 'true';
				} else {
					setTimeout(waitMine, 50);
				}
			};
			waitMine();

			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$refs.rtcGroupVideo.open(rctInfo);
			});
			this.$store.dispatch("load").then(() => {
				// 本地数据一致性校验，若异常则强制重拉
				return this.$store.dispatch("validateLocalData");
			}).then(async () => {
				const corrupted = this.$store.getters.isLocalDataCorrupted();
				if (corrupted) {
					try {
						await this.$store.dispatch("forceResyncChats");
						this.$message.warning("检测到本地消息异常，已自动重新同步");
					} catch (e) {
						console.error('forceResyncChats failed:', e);
						// 即使重同步失败，也继续初始化，避免卡死
						this.$message.warning("本地消息校验异常，将重新拉取数据");
					}
				}
				// ws初始化
				this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
				this.wsReady = true;
				// 启动一对一通话事件补偿（覆盖 WS 建连前的窗口）
				this.syncOfflineCallEvents();
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						this.pullOfflineMessage();
					}
				});
				this.$wsApi.onMessage((cmd, msgInfo) => {
					if (cmd == 2) {
						this.wsKicked = true;
						// 关闭ws
						this.$wsApi.close(3000)
						// 异地登录，强制下线
						this.$alert("您的账号已在其他地方登录，将被强制下线", "强制下线通知", {
							confirmButtonText: '确定',
							callback: action => {
								location.href = "/";
							}
						});
					} else if (msgInfo && msgInfo.action && isCallEvent(msgInfo.action)) {
						// 一对一通话事件与 IM 消息共用下行通道，按事件结构优先识别
						this.handleLivekitEvent(msgInfo);
					} else if (cmd == 3) {
						// 上下线和通话信令不进缓冲，避免登录/重连期间状态和通话被推迟。
						// 聊天、已读、撤回先入缓冲，等离线消息落地后再按到达顺序重放。
						if (this.shouldBufferRealtimeMessage(msgInfo, 'private')) {
							this.privateMessagesBuffer.push(msgInfo);
						} else {
							this.handlePrivateMessage(msgInfo);
						}
					} else if (cmd == 4) {
						if (this.shouldBufferRealtimeMessage(msgInfo, 'group')) {
							this.groupMessagesBuffer.push(msgInfo);
						} else {
							this.handleGroupMessage(msgInfo);
						}
					} else if (cmd == 5) {
						if (this.shouldBufferRealtimeMessage(msgInfo, 'system')) {
							this.systemMessagesBuffer.push(msgInfo);
						} else {
							this.handleSystemMessage(msgInfo);
						}
					}
				});
				this.$wsApi.onClose((e) => {
					if (this.wsKicked || e.code == 3000) {
						return;
					}
					// 网络断开：后台静默重连，不打断当前操作
					this.reconnectWs(false, true);
				});
			}).catch(() => {
				this.$message.error("初始化失败");
			})
		},
		async initNotification() {
			// 请求通知权限
			const hasPermission = await notificationManager.requestPermission();
			if (hasPermission) {
				console.log('桌面通知权限已获取');
			} else {
				console.warn('桌面通知权限被拒绝');
			}
		},
		reconnectWs(immediate = false, silent = false) {
			if (this.wsKicked) {
				return;
			}
			if (this.reconnecting) {
				return;
			}
			// 记录标志
			this.reconnecting = true;
			this._silentReconnect = silent || immediate;
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.$store.dispatch("loadUser").then(() => {
				const accessToken = sessionStorage.getItem("accessToken");
				if (!accessToken) {
					this.reconnecting = false;
					return;
				}
				// 静默重连：不弹提示，避免唤醒/切回时打扰用户
				if (!this._silentReconnect) {
					this.$message.warning("网络中断，正在尝试重新连接...");
				}
				const wsurl = process.env.VUE_APP_WS_URL;
				if (immediate) {
					this.$wsApi.reconnectImmediate(wsurl, accessToken);
				} else {
					this.$wsApi.reconnect(wsurl, accessToken);
				}
			}).catch(() => {
				this.reconnecting = false;
				// 10s后重试（仍保持静默策略）
				setTimeout(() => this.reconnectWs(immediate, this._silentReconnect), 10000)
			})
		},
		setupVisibilityHandler() {
			this._onVisibilityChange = () => {
				if (document.visibilityState === 'hidden') {
					this.markPageHidden();
					return;
				}
				if (document.visibilityState === 'visible') {
					this.scheduleResumeFromBackground();
				}
			};
			// 切标签时页面仍可能是 visible，visibilitychange 不会来，用焦点变化补上
			this._onWindowBlur = () => {
				this.markPageHidden();
			};
			this._onWindowFocus = () => {
				this.scheduleResumeFromBackground();
			};
			document.addEventListener('visibilitychange', this._onVisibilityChange);
			window.addEventListener('blur', this._onWindowBlur);
			window.addEventListener('focus', this._onWindowFocus);
		},
		markPageHidden() {
			if (!this.lastHiddenAt) {
				this.lastHiddenAt = Date.now();
			}
		},
		scheduleResumeFromBackground() {
			if (this.visibilityResumeTimer) {
				clearTimeout(this.visibilityResumeTimer);
			}
			this.visibilityResumeTimer = setTimeout(() => {
				this.visibilityResumeTimer = null;
				this.resumeConnectionFromBackground();
			}, VISIBILITY_RESUME_DEBOUNCE_MS);
		},
		cleanupVisibilityHandler() {
			if (this.visibilityResumeTimer) {
				clearTimeout(this.visibilityResumeTimer);
				this.visibilityResumeTimer = null;
			}
			if (this._onVisibilityChange) {
				document.removeEventListener('visibilitychange', this._onVisibilityChange);
				this._onVisibilityChange = null;
			}
			if (this._onWindowBlur) {
				window.removeEventListener('blur', this._onWindowBlur);
				this._onWindowBlur = null;
			}
			if (this._onWindowFocus) {
				window.removeEventListener('focus', this._onWindowFocus);
				this._onWindowFocus = null;
			}
		},
		async resumeConnectionFromBackground() {
			if (!this.wsReady || this.wsKicked) {
				return;
			}
			if (!sessionStorage.getItem("accessToken")) {
				return;
			}
			const hiddenDuration = this.lastHiddenAt ? (Date.now() - this.lastHiddenAt) : 0;
			this.lastHiddenAt = null;

			if (this.$wsApi.isConnected()) {
				// 短时间切走：补发心跳即可
				if (hiddenDuration < LONG_BACKGROUND_MS) {
					this.$wsApi.resetHeartbeat();
					return;
				}
				// 长时间后台：先探测是否僵死，存活则只心跳，无感恢复
				try {
					const alive = await this.$wsApi.probeConnection(CONNECTION_PROBE_MS);
					if (alive) {
						this.$wsApi.resetHeartbeat();
						return;
					}
				} catch (e) {
					console.warn('连接探测失败，准备静默重连', e);
				}
				this.$wsApi.abortConnection();
			}

			if (!this.reconnecting) {
				this.reconnectWs(true, true);
			}
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重连后补拉通话事件，避免断线期间漏接来电
			this.pullLivekitEvents();
			const silent = !!this._silentReconnect;
			this._silentReconnect = false;
			// 标记为重连状态：同步期间保持界面可用，不打断用户
			this.$store.commit("setIsReconnecting", true);
			// 重新加载群和好友
			const promises = [];
			promises.push(this.$store.dispatch("loadFriend"));
			promises.push(this.$store.dispatch("loadGroup"));
			Promise.all(promises).then(() => {
				// 断线重连：全量拉取，增量合并，一次性落库（确保不会漏消息）
				// 将现有会话复制到 cacheChats，等所有消息加载完成后再展示
				const currentChats = this.$store.getters.findChats();
				this.$store.commit("initChats", {
					chats: currentChats,
					privateMsgMaxId: this.$store.state.chatStore.privateMsgMaxId,
					groupMsgMaxId: this.$store.state.chatStore.groupMsgMaxId,
					systemMsgMaxSeqNo: this.$store.state.chatStore.systemMsgMaxSeqNo
				});
				this.pullOfflineMessage();
			}).catch(() => {
				this.$store.commit("setIsReconnecting", false);
				if (!silent) {
					this.$message.error("初始化失败");
				}
				this.onExit();
			})
		},

		isInBatchCache(chatInfo, msg) {
			if (!this.batchIdCache) return false;
			const key = `${chatInfo.type}_${chatInfo.targetId}`;
			const s = this.batchIdCache[key];
			if (!s) return false;
			// 系统消息：seqNo 必须存在且 > 0
			if (chatInfo.type === 'SYSTEM') {
				return !!(msg.seqNo && msg.seqNo > 0 && s.has(msg.seqNo));
			}
			// 其他消息：id 必须存在且 > 0（避免 id=0 的发送中消息被误判）
			return !!(msg.id && msg.id > 0 && s.has(msg.id));
		},
		shouldBufferRealtimeMessage(msg, channel) {
			if (!this.$store.getters.isLoading()) {
				return false;
			}
			const type = msg && msg.type;
			if (channel === 'private') {
				if (type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
					return false;
				}
			} else if (channel === 'group') {
				if (this.$msgType.isRtcGroup(type)) {
					return false;
				}
			} else if (channel === 'system') {
				if (type == this.$enums.MESSAGE_TYPE.USER_BANNED
					|| type == this.$enums.MESSAGE_TYPE.USER_UNREG
					|| type == this.$enums.MESSAGE_TYPE.USER_PWDEDITED) {
					return false;
				}
			}
			return true;
		},
		flushRealtimeMessageBuffers() {
			const privateMessages = this.privateMessagesBuffer;
			const groupMessages = this.groupMessagesBuffer;
			const systemMessages = this.systemMessagesBuffer;
			this.privateMessagesBuffer = [];
			this.groupMessagesBuffer = [];
			this.systemMessagesBuffer = [];
			privateMessages.forEach(m => this.handlePrivateMessage(m));
			groupMessages.forEach(m => this.handleGroupMessage(m));
			systemMessages.forEach(m => this.handleSystemMessage(m));
		},
		pullOfflineMessage() {
			let timeStamp = new Date().getTime();
			this.$store.commit("setLoading", true);
			const promises = [];
			promises.push(this.pullPrivateOfflineMessage(0));
			promises.push(this.pullGroupOfflineMessage(0));
			promises.push(this.pullSystemOfflineMessage(0));
			Promise.all(promises).then(messages => {
				// 处理离线消息
				messages[0].forEach(m => this.handlePrivateMessage(m));
				messages[1].forEach(m => this.handleGroupMessage(m));
				messages[2].forEach(m => this.handleSystemMessage(m));
				// 先摘下缓冲再重放。loading 仍为 true，消息写入 cacheChats，
				// 避免 setLoading(false) 之后插入被 refreshChats 覆盖掉。
				this.flushRealtimeMessageBuffers();
				// 关闭加载离线标记
				this.$store.commit("setLoading", false);
				this.$store.commit("setIsReconnecting", false);
				// 刷新会话
				this.$store.commit("refreshChats");
				// 打印耗时
				let size = messages[0].length + messages[1].length + messages[2].length;
				let time = new Date().getTime() - timeStamp;
				console.log("加载离线消息耗时:", time, ",消息数量:", size)
			}).catch((e) => {
				console.log(e)
				this.privateMessagesBuffer = [];
				this.groupMessagesBuffer = [];
				this.systemMessagesBuffer = [];
				this.$store.commit("setLoading", false);
				this.$store.commit("setIsReconnecting", false);
				this.$message.error("拉取离线消息失败");
				this.onExit();
			})
		},

		pullPrivateOfflineMessage(minId) {
			return this.$http({
				url: "/message/private/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullGroupOfflineMessage(minId) {
			return this.$http({
				url: "/message/group/loadOfflineMessage?minId=" + minId,
				method: 'GET'
			})
		},
		pullSystemOfflineMessage(minSeqNo) {
			return this.$http({
				url: "/message/system/loadOfflineMessage?minSeqNo=" + minSeqNo,
				method: 'GET'
			})
		},

		/**
		 * 一对一通话事件补偿
		 * 实时事件由 WebSocket 推送；此处只在登录初始化后补拉一次，
		 * 覆盖 WebSocket 连接建立前产生的事件。断线重连后由 onReconnectWs 再次补拉。
		 */
		syncOfflineCallEvents() {
			this.livekitEventMinId = 0
			this.processedLivekitEvents = {}
			this.pullLivekitEvents()
		},
		pullLivekitEvents() {
			if (this.livekitEventPulling || !sessionStorage.getItem("accessToken")) {
				return
			}
			this.livekitEventPulling = true
			livekitPrivateApi.offlineMessage(this.livekitEventMinId).then((events) => {
				if (!Array.isArray(events) || !events.length) {
					return
				}
				events.forEach((event) => {
					if (!event || !event.id) {
						return
					}
					if (event.id > this.livekitEventMinId) {
						this.livekitEventMinId = event.id
					}
					if (this.processedLivekitEvents[event.id]) {
						return
					}
					this.processedLivekitEvents[event.id] = true
					this.handleLivekitEvent(event)
				})
				// 游标已推进，去重表只保留近期事件
				if (Object.keys(this.processedLivekitEvents).length > 500) {
					this.processedLivekitEvents = {}
				}
			}).catch(() => {
				// 拉取失败不打断登录流程，下一轮重试
			}).finally(() => {
				this.livekitEventPulling = false
			})
		},
		handleLivekitEvent(event) {
			if (!event) {
				return
			}
			// 事件体与 IM 消息字段命名不同，统一为事件结构后再分发
			const normalized = {
				id: event.id,
				action: event.action,
				content: event.content,
				sender: event.sender != null ? event.sender : event.sendId,
				receiver: event.receiver != null ? event.receiver : event.recvId
			}
			const rtc = this.$refs.rtcPrivateVideo
			if (rtc && rtc.handleCallEvent) {
				rtc.handleCallEvent(normalized)
			}
		},

		handlePrivateMessage(msg) {
			const myId = this.$store.state.userStore.userInfo.id;
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
				const payload = this.parseMessageContent(msg.content);
				if (payload) {
					this.$store.commit("updateOnlineStatus", payload);
				}
				return;
			}
			// 跨账号防串号校验：仅处理与当前用户相关的消息（LOADING 已在上方放行）
			if (!(msg.sendId == myId || msg.recvId == myId)) {
				return;
			}
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			// 好友id
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			// 会话信息
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friendId
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				this.$store.commit("readedMessage", {
					friendId: msg.sendId
				})
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}
			// 好友申请
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
				const request = JSON.parse(msg.content);
				this.$store.commit("addRequest", request);
				// 显示好友申请通知
				this.showDesktopNotification(msg, request, 'friend_request');
				return;
			}
			// 好友申请被同意、拒绝、撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT
				|| msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL) {
				this.$store.commit("removeRequest", JSON.parse(msg.content).id)
				return;
			}
			// 入群申请推送（管理员收到）
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_JOIN_REQ_APPLY) {
				const request = this.parseMessageContent(msg.content);
				if (request) {
					this.$store.commit("addJoinRequest", request);
					this.showDesktopNotification(msg, request, 'group_join_request');
				}
				return;
			}
			// 入群申请被拒绝推送（申请人/审核侧同步）
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_JOIN_REQ_REJECT) {
				const request = this.parseMessageContent(msg.content);
				if (request) {
					this.$store.commit("updateMyJoinRequestStatus", request);
					this.showDesktopNotification(msg, request, 'group_join_request_reject');
				}
				return;
			}
			// 新增好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.$store.commit("addFriend", JSON.parse(msg.content));
				return;
			}
			// 删除好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.$store.commit("removeFriend", friendId);
				return;
			}
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				if (!this.$store.getters.isFriend(friendId) || this.$store.getters.isHiddenPrivateChat(friendId)) {
					return;
				}
				let friend = this.loadFriendInfo(friendId);
				this.insertPrivateMessage(friend, msg);
			}
		},
		insertPrivateMessage(friend, msg) {
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.showNickName,
				headImage: friend.headImage,
				userTag: friend.userTag != null ? friend.userTag : msg.userTag
			};
			this.$store.commit("openChat", chatInfo);
			this.$store.commit("insertMessage", [msg, chatInfo]);
			if (!msg.selfSend && this.$msgType.isNormal(msg.type) &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
				this.showDesktopNotification(msg, friend, 'private');
			}
		},
		handleGroupMessage(msg) {
			// 标记这条消息是不是自己发的（用于放行自发消息）
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				return;
			}
			// ===== 优先级2: 群管理消息（必须在成员检查之前处理，以便建立/更新群资料） =====
			// 这些消息用于同步群列表状态，即使在群列表未完全同步时也需要处理
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				// 新增群：将群信息添加到群列表
				this.$store.commit("addGroup", JSON.parse(msg.content));
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				// 删除群：从群列表中移除群
				this.$store.commit("removeGroup", msg.groupId);
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
				// 群消息置顶：更新群的置顶消息
				let topMessage = msg.content ? JSON.parse(msg.content) : null;
				this.$store.commit("updateTopMessage", [msg.groupId, topMessage]);
				return;
			}

			// ===== 优先级3: 跨账号防串号检查 =====
			// 对于非群管理消息，需要检查用户是否在该群中
			// 自发消息总是放行（用户自己发送的消息应该显示）
			// 群管理消息已在上面处理，这里不再检查
			if (!msg.selfSend && !this.$store.getters.isGroup(msg.groupId)) {
				// 非自发消息且用户不在该群时，丢弃消息（防止跨账号消息串号）
				return;
			}

			// ===== 优先级4: 消息状态类处理 =====
			// 消息已读处理
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.$store.commit("updateMessage", [msgInfo, chatInfo])
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}

			// ===== 优先级5: RTC 信令消息 =====
			// 群视频/语音通话信令（需要实时处理，已通过成员检查）
			if (this.$msgType.isRtcGroup(msg.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(msg);
				})
				return;
			}
			// 将自己的申请进群状态进行修改
			if (msg.type == this.$enums.MESSAGE_TYPE.TIP_TEXT) {
				const list = this.$store.state.groupStore.myJoinRequests.find(item => item.groupId == msg.groupId);
				if (list && list.status == 1) {
					this.$store.dispatch("loadMyJoinRequests").catch(() => { });
				}
			}

			// ===== 优先级6: 普通消息插入 =====
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.tryIncreaseGroupMemberCount(group, msg);
				this.insertGroupMessage(group, msg);
			}
		},
		tryIncreaseGroupMemberCount(group, msg) {
			if (!group || !msg || msg.type != this.$enums.MESSAGE_TYPE.TIP_TEXT) {
				return;
			}
			const sendTime = Number(msg.sendTime);
			const recentWindowMs = 40 * 1000;
			if (!Number.isFinite(sendTime) || Math.abs(Date.now() - sendTime) > recentWindowMs) {
				return;
			}
			if (!/^欢迎加入[:：]/.test(msg.content || "")) {
				return;
			}
			if (msg.id && this.processedJoinTipIds[msg.id]) {
				return;
			}
			if (msg.id) {
				this.processedJoinTipIds[msg.id] = true;
			}
			const currentCount = Number(group.memberCount);
			const nextCount = Number.isFinite(currentCount) ? currentCount + 1 : 1;
			this.$store.commit("updateGroup", {
				id: group.id,
				memberCount: nextCount
			});
		},
		insertGroupMessage(group, msg) {
			let chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb
			};
			this.$store.commit("openChat", chatInfo);
			this.$store.commit("insertMessage", [msg, chatInfo]);
			const chats = this.$store.getters.findChats();
			let isNotDisturb = false;
			chats.forEach(chat => {
				if (chat.type == chatInfo.type && chat.targetId == chatInfo.targetId) {
					isNotDisturb = chat.isNotDisturb;
				}
			});
			if (!msg.selfSend && msg.type <= this.$enums.MESSAGE_TYPE.VIDEO &&
				msg.status != this.$enums.MESSAGE_STATUS.READED && !isNotDisturb) {
				this.playAudioTip();
				this.showDesktopNotification(msg, group, 'group');
			}
		},
		handleSystemMessage(msg) {
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				return;
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.$store.commit("resetUnreadCount", {
					type: 'SYSTEM',
					targetId: 0
				})
				return;
			}
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 修改密码
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_PWDEDITED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号密码已修改，请退出重新登录！", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			// 用户账户注销
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已注销", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
			this.insertSystemMessage(msg);
		},
		insertSystemMessage(msg) {
			let headImage = require('@/assets/image/chat_system.png');
			let chatInfo = {
				type: 'SYSTEM',
				targetId: 0,
				showName: "系统通知",
				headImage: headImage
			};
			this.$store.commit("openChat", chatInfo);
			this.$store.commit("insertMessage", [msg, chatInfo]);
			this.showDesktopNotification(msg, null, 'system');
		},
		showDesktopNotification(msg, contact, type) {
			// 检查是否应该显示通知
			if (!this.shouldShowNotification(msg, type)) {
				return;
			}

			try {
				switch (type) {
					case 'private':
						notificationManager.showPrivateMessageNotification(msg, contact);
						break;
					case 'group':
						notificationManager.showGroupMessageNotification(msg, contact);
						break;
					case 'system':
						notificationManager.showSystemMessageNotification(msg);
						break;
					case 'friend_request':
						notificationManager.showFriendRequestNotification(contact);
						break;
					case 'group_join_request':
						notificationManager.showGroupJoinRequestNotification(contact);
						break;
					case 'group_join_request_reject':
						notificationManager.showGroupJoinRequestRejectNotification(contact);
						break;
				}
			} catch (error) {
				console.error('显示桌面通知失败:', error);
			}
		},
		setupNotificationListeners() {
			// 通知点击回流事件：处理函数抽为具名方法，移除时才能命中同一引用
			window.addEventListener('focusChat', this.onNotificationFocusChat);
			window.addEventListener('navigateTo', this.onNotificationNavigateTo);
			window.addEventListener('acceptCall', this.onNotificationAcceptCall);
			window.addEventListener('rejectCall', this.onNotificationRejectCall);
		},
		onNotificationFocusChat(event) {
			const { type, targetId } = event.detail;
			this.focusChat(type, targetId);
		},
		onNotificationNavigateTo(event) {
			const { path } = event.detail;
			this.$router.push(path);
		},
		onNotificationAcceptCall(event) {
			const { callInfo, type } = event.detail;
			this.acceptCall(callInfo, type);
		},
		onNotificationRejectCall(event) {
			const { callInfo, type } = event.detail;
			this.rejectCall(callInfo, type);
		},
		focusChat(type, targetId) {
			// 切换到对应的聊天
			const chatInfo = { type, targetId };
			this.$store.commit("openChat", chatInfo);

			// 如果不在聊天页面，跳转到聊天页面
			if (this.$route.path !== '/home/chat') {
				this.$router.push('/home/chat');
			}
		},
		acceptCall(callInfo, type) {
			// 通知栏接听：来电卡片处于响铃态时交由通话组件接听
			const rtc = this.$refs.rtcPrivateVideo;
			if (rtc && rtc.isRinging) {
				rtc.onAccept();
			}
		},
		cleanupNotificationListeners() {
			// 注册与移除必须使用同一个函数引用，匿名函数无法被 removeEventListener 命中
			window.removeEventListener('focusChat', this.onNotificationFocusChat);
			window.removeEventListener('navigateTo', this.onNotificationNavigateTo);
			window.removeEventListener('acceptCall', this.onNotificationAcceptCall);
			window.removeEventListener('rejectCall', this.onNotificationRejectCall);
		},
		rejectCall(callInfo, type) {
			// 通知栏拒绝：来电卡片处于响铃态时交由通话组件拒绝
			const rtc = this.$refs.rtcPrivateVideo;
			if (rtc && rtc.isRinging) {
				rtc.onReject();
			}
		},
		shouldShowNotification(msg, type) {
			// 如果是自己发送的消息，不显示通知
			if (msg.selfSend) {
				return false;
			}

			// 如果消息已读，不显示通知
			if (msg.status === this.$enums.MESSAGE_STATUS.READED) {
				return false;
			}

			// 检查是否开启了免打扰
			if (type === 'group') {
				const chats = this.$store.state.chatStore.chats;
				let isNotDisturb = false;
				chats.forEach(chat => {
					if (chat.type === 'GROUP' && chat.targetId === msg.groupId) {
						isNotDisturb = chat.isNotDisturb;
					}
				});
				if (isNotDisturb) {
					return false;
				}
			}

			// 检查是否禁用了桌面通知
			if (localStorage.getItem(getUserKey('notificationEnabled', this.mine.id)) === "false") {
				return false;
			}

			// 好友申请通知总是显示（除非页面可见且窗口未最小化）
			if (type === 'friend_request') {
				return true;
			}
			// 入群申请通知总是显示（除非页面可见且窗口未最小化）
			if (type === 'group_join_request') {
				return true;
			}
			// 入群申请拒绝通知总是显示（除非页面可见且窗口未最小化）
			if (type === 'group_join_request_reject') {
				return true;
			}

			return true;
		},
		onExit() {
			this.wsKicked = true;
			this.$wsApi.close(3000);
			// 清理批量缓存
			this.clearBatchIdCache();
			sessionStorage.removeItem("accessToken");
			sessionStorage.removeItem("refreshToken");
			location.href = "/";
		},
		clearBatchIdCache() {
			const userId = this.$store.state.userStore.userInfo.id;
			if (userId) {
				try {
					const cacheKey = `batchIdCache-${userId}`;
					sessionStorage.removeItem(cacheKey);
				} catch (e) {
					// 忽略错误
				}
			}
			this.batchIdCache = null;
		},
		playAudioTip() {
			// 离线消息不播放铃声
			if (this.$store.getters.isLoading()) {
				return;
			}
			if (localStorage.getItem(getUserKey('isCloseVoice', this.mine.id)) === "true") {
				return;
			}
			// 防止过于密集播放
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.wav`);
				audio.src = url;
				audio.play();
			}

		},
		showSetting() {
			this.$refs.setting.open();
		},
		loadFriendInfo(id) {
			let friend = this.$store.getters.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.$store.getters.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		},
		parseMessageContent(content) {
			if (!content) {
				return null;
			}
			if (typeof content === "object") {
				return content;
			}
			try {
				return JSON.parse(content);
			} catch (e) {
				return null;
			}
		},
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		uiStore() {
			return this.$store.state.uiStore;
		},
		unreadCount() {
			let unreadCount = 0;
			let chats = this.$store.state.chatStore.chats;
			chats.forEach((chat) => {
				if (!chat.delete) {
					unreadCount += chat.unreadCount
				}
			});
			return unreadCount;
		},
		recvCount() {
			let requests = this.$store.state.friendStore.requests;
			return requests.filter((req) => req.recvId == this.mine.id).length;
		},
		groupApplyCount() {
			return this.$store.state.groupStore.joinRequests.length;
		}
	},
	destroyed() {
		this.cleanupVisibilityHandler();
		this.cleanupNotificationListeners();
		this.$wsApi.close();
		// 清理批量同步完成事件监听
		this.$eventBus.$off('batchSyncComplete');
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
			},
			immediate: true
		},
	},
	mounted() {
		this.bindH5Layout();
		this.$wsApi.close();
		this.init();
		this.setupVisibilityHandler();
		this.$store.dispatch("loadGroupJoinRequests").catch(() => { });
		// 监听通知点击事件
		this.setupNotificationListeners();
	},
	beforeDestroy() {
		this.unbindH5Layout();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	.app-container {
		width: 62vw;
		height: 80vh;
		display: flex;
		min-height: 600px;
		min-width: 970px;
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		transition: 0.2s;

		&.fullscreen {
			transition: 0.2s;
			width: 100vw;
			height: 100vh;
		}
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 60px;
		width: var(--width);
		background: var(--im-color-primary-light-1);
		padding-top: 20px;

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.botoom {
				margin-bottom: 30px;
			}
		}

		.user-head-image {
			display: flex;
			justify-content: center;
		}

		.menu {
			height: 200px;
			//margin-top: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;

			.link {
				text-decoration: none;
			}

			.router-link-active .menu-item {
				color: #fff;
				background: var(--im-color-primary-light-2);
			}

			.link:not(.router-link-active) .menu-item:hover {
				color: var(--im-color-primary-light-7);
			}

			.menu-item {
				position: relative;
				color: var(--im-color-primary-light-4);
				width: var(--width);
				height: 46px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 12px;

				.icon {
					font-size: var(--icon-font-size)
				}

				.unread-text {
					position: absolute;
					background-color: var(--im-color-danger);
					left: 30px;
					top: 5px;
					color: white;
					border-radius: 30px;
					padding: 0 6px;
					font-size: var(--im-font-size-smaller);
					text-align: center;
					white-space: nowrap;
					border: 1px solid #f1e5e5;
					transform: translate(-20%, -40%);
				}
			}
		}

		.botoom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 50px;
			width: 100%;
			cursor: pointer;
			color: var(--im-color-primary-light-6);
			font-size: var(--icon-font-size);

			.icon {
				font-size: var(--icon-font-size)
			}

			&:hover {
				font-weight: 600;
				color: var(--im-color-primary-light-9);
			}

			&.disabled {
				pointer-events: none;
				opacity: 0.5;
				cursor: not-allowed;
			}

			a {
				color: var(--im-color-primary-light-4);

				:hover {
					color: var(--im-color-primary-light-9);
				}
			}
		}
	}

	.content-box {
		flex: 1;
		padding: 0;
		background-color: #fff;
		text-align: center;
	}

	&.is-h5 {
		height: 100%;
		width: 100%;
		align-items: stretch;
		justify-content: flex-start;

		.app-container,
		.app-container.fullscreen {
			position: relative;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			min-width: 0;
			min-height: 0;
			border-radius: 0;
			box-shadow: none;
			flex-direction: column;
			overflow: hidden;
		}

		.content-box {
			flex: 1;
			min-height: 0;
			min-width: 0;
			width: 100%;
			display: flex;
			flex-direction: column;
		}

		.navi-bar {
			order: 2;
			width: 100%;
			padding: 0;
			padding-bottom: env(safe-area-inset-bottom, 0px);
			flex-shrink: 0;
			border-top: var(--im-border);

			.navi-bar-box {
				height: 56px;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				padding: 0 4px;
			}

			.top {
				display: flex;
				align-items: center;
				flex: 1;
				min-width: 0;
			}

			.user-head-image {
				padding: 0 4px;
				flex-shrink: 0;
			}

			.menu {
				flex-direction: row;
				height: auto;
				flex: 1;
				justify-content: space-around;

				.menu-item {
					width: 44px;
					height: 44px;
					margin-bottom: 0;
				}
			}

			.botoom {
				display: flex;
				flex-direction: row;
				margin-bottom: 0;
				flex-shrink: 0;
			}

			.botoom-item {
				width: 40px;
				height: 44px;
			}
		}
	}
}
</style>
